// extracted by mini-css-extract-plugin
export default {"textContainer":"aiSolutionCaseStudy_textContainer__jsInr","overlay":"aiSolutionCaseStudy_overlay__HS4p4","heading":"aiSolutionCaseStudy_heading__+fzhV"};